const MAIL_TYPES = {
  GMAIL: "GMAIL",
  OUTLOOK: "OUTLOOK",
  HOTMAIL: "HOTMAIL",
  OTHER: "OTHER",
  MAILTOO: "MAILTOO"
}
export default MAIL_TYPES
